import { Divider, List } from "antd";
import { useMemo, useState } from "react";
import { currency, groupChildren } from "./subscriptionDrawerUtil";
import { GroupedLicenseRow, LicenseRow, useLicensesActions, useLicensesState } from "src/reducers/subscription";

import SubscriptionDrawerChildrenGroupsListItem from "./SubscriptionDrawerChildrenGroupsListItem";
import SubscriptionDrawerManageGroupModal from "./SubscriptionDrawerManageGroupModal";

const SubscriptionDrawerChildrenGroupsList = () => {

    const { managementDrawerOpen, selected } = useLicensesState();
    const { load, setSelectedRow, setManagementDrawerOpen } = useLicensesActions();

    const [showManageDrawer, setShowManageDrawer] = useState(false);
    const [selectedGroup, setSelectedGroup] = useState<GroupedLicenseRow | null>(null);


    
    const groupedChildren = useMemo(
        () => groupChildren(selected?.children || []),
        [selected, selected?.children]
    );

    const onClickManage = (group: GroupedLicenseRow) => {
        setSelectedGroup(group);
        setShowManageDrawer(true);


    }

    const onClickCancelHandlerFromManageGroup = (child: LicenseRow) => {
        load(() => {
            setSelectedRow(selected.Id);
            setSelectedGroup(null);
            setShowManageDrawer(false);
        });
    }

    return (<>
        <Divider orientation="left">Alt Lisanslar</Divider>

        <SubscriptionDrawerManageGroupModal group={selectedGroup} onCancelChild={onClickCancelHandlerFromManageGroup} onClose={() => setShowManageDrawer(false)} open={showManageDrawer} />

        <List
            itemLayout="horizontal"
            dataSource={groupedChildren}
            renderItem={(group) => (
                <SubscriptionDrawerChildrenGroupsListItem

                    onCancelSingle={onClickCancelHandlerFromManageGroup}
                    onManage={onClickManage}
                    group={group} />
            )}
        />
    </>)
}


export default SubscriptionDrawerChildrenGroupsList;